












































import { Component, Vue } from 'vue-property-decorator';

import ContactSection from '../components/homepage/ContactSection.vue';
import EventSection from '../components/homepage/EventSection.vue';

@Component({
  components: {
    EventSection,
    ContactSection,
  },
})
export default class HomePage extends Vue {}
